var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66335 1C6.70332 1 5.93318 1.8974 5.93318 2.97753V5.80478C5.66384 5.9207 5.40371 6.05764 5.16851 6.23736C4.61291 6.66189 4.20301 7.33509 4.20301 8.16854V11.3434C4.20251 11.3563 4.20251 11.3691 4.20301 11.382V16.8202C4.20202 16.8382 4.20202 16.8563 4.20301 16.8743V19.7865C4.20301 21.4213 5.5344 22.7528 7.16902 22.7528H10.8765H14.584C16.2187 22.7528 17.55 21.4213 17.55 19.7865V16.8588C17.5505 16.846 17.5505 16.8331 17.55 16.8202V11.382C17.5508 11.3666 17.5508 11.3511 17.55 11.3357V8.16854C17.55 7.33509 17.1401 6.66188 16.5845 6.23736C16.3493 6.05764 16.0892 5.9207 15.8199 5.80478V2.97753C15.8199 1.8974 15.0497 1 14.0897 1H7.66335ZM7.66335 1.98876H14.0897C14.3128 1.98876 14.8312 2.41433 14.8312 2.97753V5.44944H14.584H7.12267H6.92185V2.97753C6.92185 2.41433 7.4403 1.98876 7.66335 1.98876ZM7.21536 6.4382H14.5377C15.0901 6.55447 15.6229 6.75087 15.9821 7.02528C16.3534 7.30896 16.5614 7.63255 16.5614 8.16854V9.97097H5.19168V8.16854C5.19168 7.63255 5.3997 7.30896 5.77098 7.02528C6.13012 6.75087 6.66296 6.55447 7.21536 6.4382ZM5.19168 10.9597H16.5614V16.3258H5.19168V10.9597ZM5.19168 17.3146H16.5614V19.7865C16.5614 20.8906 15.688 21.764 14.584 21.764H10.8765H7.16902C6.06502 21.764 5.19168 20.8906 5.19168 19.7865V17.3146Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1295_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3132V14.9868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54169 13.65H12.4584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1295_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4.58333,
    fill: "white",
    transform: "translate(8.5 11.3583)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplements);
export default __webpack_public_path__ + "static/media/supplements.37beb9bf739ec951e69aa6d94f67bb02.svg";
export { ForwardRef as ReactComponent };